module.exports = __webpack_public_path__ + "static/media/sopt1kz.798fe757.pdf";